module.exports = __webpack_public_path__ + "img/summary-icon.e22d77fc.svg";